import { Component, OnInit } from '@angular/core';
import { ModalService } from './modal-list.service';
import { Modal } from './modal.model';
import { WindowRef } from '@spartacus/core';

@Component({
  selector: 'modal-list',
  templateUrl: './modal-list.component.html',
  styleUrl: './modal-list.component.scss',
  standalone: false,
})
export class ModalComponent implements OnInit {
  modal$ = this.modalService.getActiveModal();

  constructor(
    private winRef: WindowRef,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.handleKeyboardEvent();
  }

  close(el: any) {
    const isContainer =
      el && el.target && el.target.classList && el.target.classList.contains('js-container-modal-list');
    const modals = this.modalService.getAllAsValue();
    const modal: Modal = modals[modals.length - 1];

    if (isContainer) {
      if (modal.onSkip) {
        modal.onSkip();
      } else {
        this.modalService.close();
      }
    }
  }

  handleKeyboardEvent() {
    const _this = this;

    this.winRef.isBrowser() &&
      this.winRef.document.body.addEventListener('keyup', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          _this.modalService.skip();
        }
      });
  }
}
